export default __webpack_public_path__ + "static/media/invoice-marker.d3378c1d.svg";